import { render, staticRenderFns } from "./CourseVideos.vue?vue&type=template&id=512935e0&scoped=true"
import script from "./CourseVideos.vue?vue&type=script&lang=js"
export * from "./CourseVideos.vue?vue&type=script&lang=js"
import style0 from "./CourseVideos.vue?vue&type=style&index=0&id=512935e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512935e0",
  null
  
)

export default component.exports